// Centralized colors object
export const colors = {
  base: {
    0: '#FFFFFF',
    50: '#F6F7F7',
    75: '#F9FAFB',
    100: '#EAEAEA',
    200: '#DFE1E1',
    300: '#C8CACA',
    400: '#A9ACAC',
    500: '#8A8E8E',
    600: '#6D7171',
    700: '#515555',
    800: '#363A3A',
    900: '#1C1F1F',
    1000: '#000000',
  },
  brand: {
    50: '#FFF8E1',
    100: '#FFECB3',
    200: '#FFE082',
    300: '#FFE396',
    400: '#FFCA28',
    500: '#F7CC55',
    600: '#FFC72C',
    700: '#D6A00A',
    800: '#E65100',
    900: '#BF360C',
  },
  success: {
    50: '#EDFDF3',
    100: '#D6F5E5',
    200: '#9AEAC0',
    300: '#72E3A9',
    400: '#48DD91',
    500: '#25D57A',
    600: '#1CAD62',
    700: '#17824B',
    800: '#105632',
    900: '#082B19',
  },
  error: {
    50: '#FDEEEE',
    100: '#FADBDB',
    200: '#F78686',
    300: '#F59999',
    400: '#F38181',
    500: '#F26464',
    600: '#F24848',
    700: '#D91212',
    800: '#900E0E',
    900: '#460707',
  },
  warning: {
    50: '#FFF5E4',
    100: '#FCEBC9',
    200: '#FCD388',
    300: '#FCC764',
    400: '#FDBC44',
    500: '#FFB020',
    600: '#D48B02',
    700: '#8C5C03',
    800: '#462E02',
    900: '#462E02',
  },
  info: {
    50: '#EEF6FD',
    100: '#DAECF6',
    200: '#80D7ED',
    300: '#8DC6E7',
    400: '#6EBBE2',
    500: '#4FAADE',
    600: '#2D9CDB',
    700: '#1F76A8',
    800: '#164E6F',
    900: '#0B2737',
  },
};

export const themePalette = {
  default: {
    element_brand: colors.brand[600],
    primary_background: colors.base[100],
    element_black: colors.base[900],
  },
  primary: {
    blue: '0072CE',
  },
  hover: {
    brand_hover: colors.brand[500],
    primary_hover: colors.base[50],
    black_hover: colors.base[800],
  },
  pressed: {
    brand_pressed: colors.brand[700],
    primary_pressed: colors.base[200],
    black_pressed: colors.base[1000],
  },
  inactive: {
    brand_inactive: colors.brand[300],
    primary_inactive: colors.base[300],
    black_inactive: colors.base[700],
  },
  text_and_icon: {
    primary: colors.base[900],
    third_party: colors.base[500],
    nested: colors.base[0],
    success: colors.success[600],
    secondary: colors.base[700],
    error: colors.error[600],
  },
};
